import { Component, OnInit } from '@angular/core';
import { ThemeService } from './core/services/theme.service';
import { RouterOutlet } from '@angular/router';
import { NgClass } from '@angular/common';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ConfirmationService, MessageService, PrimeNGConfig } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'primeng/dynamicdialog';
import { OltService } from '@modules/clients/services/olt/olt.service';
import { SmartOltService } from '@modules/network-manager/services/smart-olt/smart-olt.service';
import { InstallationService } from '@modules/clients/services/installation/installation.service';
import { CompaniesService } from '@modules/configs/pages/companies/services/companies.service';
import { GlobalStateService } from 'src/app/shared/services/global-state/global-state.service';
import { AuthService } from '@modules/auth/services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [NgClass, RouterOutlet, AngularSvgIconModule, ConfirmDialogModule, ToastModule],
  providers: [
    MessageService,
    ConfirmationService,
    ToastrService,
    DialogService,
    OltService,
    SmartOltService,
    ConfirmationService,
    InstallationService,
  ],
})
export class AppComponent implements OnInit {
  constructor(
    public themeService: ThemeService,
    private config: PrimeNGConfig,
    private readonly companiesService: CompaniesService,
    private readonly globalState: GlobalStateService,
    private readonly authService: AuthService,
  ) {
    this.config.setTranslation({
      dayNames: ['Domingo', 'Lunes', 'Mártes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
      dayNamesShort: ['Dom', 'Lum', 'Mar', 'Mie', 'Jue', 'Vie', 'Sa'],
      dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
      monthNames: [
        'Enero',
        'Febrero',
        'Marzo',
        'April',
        'Mayo',
        'Junio',
        'Julio',
        'Augosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
      ],
      monthNamesShort: ['En', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
      today: 'Hoy',
      clear: 'Limpiar',
      dateFormat: 'dd/mm/yy',
    });
  }
  ngOnInit(): void {
    this.getCompanies();
    this.checkUser();
  }

  async getCompanies(): Promise<any> {
    await this.companiesService.getCompanies();
  }

  checkUser() {
    let user = this.authService.getUser();
    if (user.id) {
      this.globalState.setSelectedCompanyId(user.companyOwner.id);
    }
  }
}
